import React, { useEffect, useState } from 'react';
import Dialog from '../../components/Dialog/Dialog';
// import Btn from '../../components/Btn/Btn';
import styles from './Share.module.less';
import wechat from '../../static/wechat.png';
import qq from '../../static/qq.png';
import { setShareVisible } from '../../actions/layout';
import { useDispatch } from 'react-redux';
import ClipboardJS from 'clipboard';
import Toast from '../../components/Toast/Toast';
import QRCode from 'qrcode.react';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { setShareLink } from '../../actions/layout';
import { logging, logPostInfo } from '../../actions/log';
import { WEB_STORE } from '../../config';

const selectShareLink = createSelector(
  state => state.layout,
  layout => layout.shareLink,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default () => {
  const logInfoData = useSelector(selectLogInfo);
  const [qrcode, setQrcode] = useState(false);
  const dispatch = useDispatch();
  const {
    address: url,
    desc = 'hi，推荐你使用联想应用商店，商店提供上万款软件供您免费高速下载，除此之外还有精美壁纸、教育课程等丰富的内容供您使用~',
    soft = {},
    logInfo = {},
  } = useSelector(selectShareLink);
  useEffect(() => {
    const clipboard = new ClipboardJS(`.${styles.link_copy}`);
    clipboard.on('success', () => {
      Toast.success({
        content: '复制成功',
      });
    });
    clipboard.on('error', () => {
      Toast.error({
        content: '复制失败',
      });
    });

    // 展现打桩
    dispatch(
      logging({
        category: 'P',
        action: 'Store_Window_Share',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: (soft && soft.softID) || null,
          softType: (soft && '0') || null,
        },
        param3: (soft && soft.bizInfo) || null,
      }),
    );

    return () => {
      clipboard.destroy();
    };
  }, []);
  useEffect(() => {
    return () => {
      dispatch(setShareLink({}));
    };
  }, []);

  const handelSkipQQ = () => {
    const URL = encodeURIComponent(`${url}?origin=pcstore_qq`);
    const TITLE = encodeURIComponent('联想应用商店');
    const DESCRIPTION = encodeURIComponent('');
    const SUMMARY = encodeURIComponent('');
    // const SOURCE = encodeURIComponent('https://wiki.connect.qq.com/api%e5%88%97%e8%a1%a8');
    const SOURCE = encodeURIComponent(URL);
    const IMAGE = '';
    window.open(
      `https://connect.qq.com/widget/shareqq/index.html?url=${URL}&title=${TITLE}&source=${SOURCE}&desc=${DESCRIPTION}&pics=${IMAGE}&summary=${SUMMARY}&site=${SOURCE}`,
    );
    // 打桩

    dispatch(
      logging({
        category: 'C',
        action: 'Store_Share_QQ',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: (soft && soft.softID) || null,
          softType: (soft && '0') || null,
        },
        param3: (soft && soft.bizInfo) || null,
      }),
    );
  };

  const handleSkipWechat = () => {
    setQrcode(true);
    // 打桩

    dispatch(
      logging({
        category: 'C',
        action: 'Store_Share_Wechat',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: (soft && soft.softID) || null,
          softType: (soft && '0') || null,
        },
        param3: (soft && soft.bizInfo) || null,
      }),
    );
  };

  const handleCopy = () => {
    // 打桩

    dispatch(
      logging({
        category: 'C',
        action: 'Store_Share_Copy',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: (soft && soft.softID) || null,
          softType: (soft && '0') || null,
        },
        param3: (soft && soft.bizInfo) || null,
      }),
    );
  };
  const handleCopyOper = e => {
    e.preventDefault(); // 这句很重要，决定setData是否成功
    e.clipboardData.setData('text', `${desc} 详情查看：${url}`);
  };
  useEffect(() => {
    const nodes = document.getElementsByClassName(styles.link_address);
    if (nodes && nodes[0]) {
      nodes[0].addEventListener('copy', handleCopyOper);
    }
    return () => {
      if (nodes && nodes[0]) {
        nodes[0].removeEventListener('copy', handleCopyOper);
      }
    };
  }, []);
  return (
    <>
      <Dialog
        title={(soft && `分享${soft.softName}`) || '分享联想应用商店'}
        maskStyle={styles.mask}
        containerStyle={styles.mask_container}
        handleClose={() => {
          dispatch(setShareVisible(false));
        }}
      >
        <div className={styles.content}>
          <div className={styles.way}>
            <img
              src={wechat}
              alt=""
              className={styles.way_icon}
              onClick={handleSkipWechat}
              onMouseLeave={() => {
                setQrcode(false);
              }}
            />
            <img src={qq} alt="" className={styles.way_icon} onClick={handelSkipQQ} />
          </div>
          <div className={styles.link}>
            <div className={styles.link_text}>分享链接：</div>
            <div className={styles.link_address}>{url || `${WEB_STORE}/about`}</div>
            <div
              className={styles.link_copy}
              data-clipboard-action="copy"
              data-clipboard-text={`${desc} 详情查看：${url}?origin=pcstore_copylink`}
              onClick={handleCopy}
            >
              <span>复制链接</span>
            </div>
          </div>
        </div>
        {qrcode && (
          <div className={styles.qrcode}>
            {/* <i
              className={`iconfont icon-close ${styles.icon_close}`}
              onClick={() => {
                setQrcode(false);
              }}
            ></i> */}
            <div className={styles.qrcode_img}>
              <QRCode value={`${url}?origin=pcstore_wechat`} size={90} />
            </div>
            <div className={styles.qrcode_text}>打开微信扫一扫</div>
          </div>
        )}
      </Dialog>
    </>
  );
};
